import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import NotificationBell from './NotificationBell';

const CustomerHeader = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
  };

  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/dashboard')) return 'Dashboard';
    if (path.includes('/inventory')) return 'Inventory';
    if (path.includes('/requests')) return 'Requests';
    if (path.includes('/invoices')) return 'Invoices';
    if (path.includes('/company')) return 'Company';
    if (path.includes('/profile')) return 'Company';
    if (path.includes('/addresses')) return 'Addresses';
    if (path.includes('/storage-fees')) return 'Storage Fees';
    return 'Customer Portal';
  };
  
  return (
    <header className="bg-white shadow w-full">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4 h-16">
          {/* Page Title */}
          <div>
            <h1 className="text-xl font-semibold text-gray-900">{getPageTitle()}</h1>
          </div>
          
          {/* Right side items */}
          <div className="flex items-center space-x-4">
            <NotificationBell compact />

            {/* User Info and Logout */}
            <div className="flex-shrink-0 relative">
              <div className="flex items-center">
                <Link to="/customer/user" className="mr-3 hidden sm:block text-right hover:opacity-80">
                  <p className="text-sm font-medium text-gray-700">{user?.name || 'Customer'}</p>
                  <p className="text-xs text-gray-500 truncate">{user?.email || 'customer@example.com'}</p>
                </Link>
                <button
                  onClick={handleLogout}
                  className="inline-flex items-center justify-center rounded-md border border-red-300 bg-white px-3 py-2 text-sm font-medium leading-4 text-red-700 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >
                  <span className="hidden sm:inline">Logout</span>
                  <span className="sm:hidden">Exit</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CustomerHeader; 
